// extracted by mini-css-extract-plugin
export default {"videoLimitsContainer":"style_videoLimitsContainer__UJlkO","flex":"style_flex__LqnE+"};